import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "./ActionButton";
const Container = styled.div`
  width: 100%;
  height: min-content;
  margin-top: 3rem;
`;
export default function PaginationButton({
  color,
  text,
  callback,
  totalPages,
  currentPage,
  hasNextPage,
}) {
  return (
    <Container className="flex direction-column min-gap">
      <p>{`Página ${
        currentPage === totalPages ? currentPage : currentPage + 1
      } de ${totalPages}`}</p>
      {hasNextPage && (
        <Button
          color={color}
          text={`${text}`}
          $fullWidth
          action={() => callback(currentPage + 1)}
        />
      )}
    </Container>
  );
}
